import slide1 from './assets/slide-1.webp';
import slide2 from './assets/slide-2.webp';
import slide3 from './assets/slide-3.webp';
import slide4 from './assets/slide-4.webp';
import slide5 from './assets/slide-5.webp';
import slide6 from './assets/slide-6.webp';
import slide7 from './assets/slide-7.webp';

export const aboutContent = {
    title: '30 лет строим дома, <br> <span>в которых хочется жить</span>',
    textTop: 'Входим в топ-24 застройщиков по объему <br> <span>текущего строительства по рейтингу ЕРЗ</span>',
    textBottom: 'мы не просто строим квадратные метры, а создаем<br> пространства, где все продумано до мелочей — от ландшафта<br> во дворе до эргономики квартир. <span>наш опыт складывается <br> из проектов в 8 крупных городах: от Санкт-Петербурга <br> и Казани до Екатеринбурга и Махачкалы</span>',

    slides: [
        {
            id: 1,
            image: slide1,
            caption: 'Махачкала'
        },
        {
            id: 2,
            image: slide2,
            caption: 'Пермь'
        },
        {
            id: 3,
            image: slide3,
            caption: 'Казань'
        },
        {
            id: 4,
            image: slide4,
            caption: 'Екатеринбург'
        },
        {
            id: 5,
            image: slide5,
            caption: 'Тольяти'
        },
        {
            id: 6,
            image: slide6,
            caption: 'Уфа'
        },
        {
            id: 7,
            image: slide7,
            caption: 'Нижний Новгород'
        },
    ]
}